export default __webpack_public_path__ + "static/18-9e128e09b9526050811383faa0f86220.jpg";